export default __webpack_public_path__ + "static/media/am.a40f0629.webp";